import React from 'react';
import { Card, CardContent } from './ui/card';
import { ShieldCheck, BadgeCheck, Clock, Handshake } from 'lucide-react';
import { advantages, companyInfo, stats } from '../mockData';

const iconMap = {
  'shield-check': ShieldCheck,
  'badge-check': BadgeCheck,
  'clock': Clock,
  'handshake': Handshake
};

const AboutSection = () => {
  return (
    <section id="about" className="py-24 bg-gradient-to-br from-white via-blue-50/30 to-white relative overflow-hidden">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-gradient-to-br from-blue-200/30 to-blue-300/20 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto px-6 relative z-10">
        {/* Section header */}
        <div className="text-center max-w-3xl mx-auto mb-20 space-y-4">
          <span className="bg-gradient-to-r from-yellow-500 to-yellow-400 text-white px-5 py-2.5 rounded-full text-sm font-semibold shadow-lg">
            À Propos
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
            Pourquoi choisir
            <span className="block mt-2 bg-gradient-to-r from-yellow-500 to-yellow-400 bg-clip-text text-transparent">
              {companyInfo.name} ?
            </span>
          </h2>
          <p className="text-xl text-gray-600">
            Depuis {companyInfo.yearsExperience} ans, nous accompagnons nos clients dans la réalisation de leurs projets les plus ambitieux.
          </p>
        </div>

        {/* Stats cards */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-5xl mx-auto mb-16">
          {stats.map((stat, index) => (
            <Card
              key={index}
              className="bg-white border-2 border-gray-100 hover:border-yellow-200 hover:shadow-xl transition-all group cursor-pointer"
            >
              <CardContent className="p-6 text-center space-y-3">
                <div className="text-4xl font-bold bg-gradient-to-r from-yellow-500 to-yellow-400 bg-clip-text text-transparent group-hover:scale-110 transition-transform inline-block">
                  {stat.number}
                </div>
                <div className="text-sm text-gray-600 font-medium">
                  {stat.label}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Advantages grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {advantages.map((advantage, index) => {
            const IconComponent = iconMap[advantage.icon];
            return (
              <Card
                key={advantage.title}
                className="group relative overflow-hidden hover:shadow-2xl transition-all duration-300 border-2 border-gray-100 hover:border-yellow-200 cursor-pointer bg-white"
              >
                {/* Gradient overlay on hover */}
                <div className="absolute inset-0 bg-gradient-to-br from-blue-50 to-white opacity-0 group-hover:opacity-100 transition-opacity"></div>
                
                <CardContent className="p-8 space-y-4 text-center relative z-10">
                  <div className="w-16 h-16 bg-gradient-to-br from-yellow-500 to-yellow-400 rounded-2xl flex items-center justify-center mx-auto group-hover:scale-110 group-hover:rotate-3 transition-all shadow-lg">
                    <IconComponent className="text-white" size={30} />
                  </div>
                  <h3 className="font-bold text-lg text-gray-900 group-hover:text-yellow-600 transition-colors">
                    {advantage.title}
                  </h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {advantage.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
